export const spacings = {
  sp00: '0px',
  sp01: '2px',
  // Check - where 2
  sp03: '4px',
  sp04: '8px',
  sp05: '12px',
  sp06: '16px',
  sp07: '24px',
  sp08: '32px',
  sp09: '40px',
  sp10: '48px',
  sp11: '56px',
  sp12: '64px',
  sp13: '80px',
  sp14: '96px',
  sp15: '160px',
} as const;
